import { render, staticRenderFns } from "./M.vue?vue&type=template&id=71de986f&scoped=true&"
import script from "./M.vue?vue&type=script&lang=js&"
export * from "./M.vue?vue&type=script&lang=js&"
import style0 from "./M.vue?vue&type=style&index=0&id=71de986f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71de986f",
  null
  
)

export default component.exports